import { getCurrentTimestamp, getCustomFormattedDateBeginningByYear } from "../date/date-helper";

export const parseCSV = (csvData) => {
  const lines = csvData.split('\n');
  const headers = lines[0].split(',').map((header) => header.trim());
  const data = lines.slice(1).map((line) => {
    const values = line.split(',');
    const obj = {};
    headers.forEach((header, index) => {
      obj[header] = values[index].trim();
    });
    return obj;
  });
  return data;
};

export const cleanParsedData = (data) => {
  return data.map((item) => {
    const cleanedItem = {};
    for (const key in item) {
      const cleanedKey = key.replace(/"/g, '').trim();
      const cleanedValue = item[key].replace(/"/g, '').trim();
      cleanedItem[cleanedKey] = cleanedValue;
    }
    return cleanedItem;
  });
};

export const dataURLtoFile = (dataURI, filename) => {
  const arr = dataURI.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

/**
 * Create csv data from array
 * @param arrayData
 * @param separator
 * @returns {string}
 */
export const createCsvData = (arrayData, separator = ',') => {
  return 'data:text/csv;charset=utf-8,' + arrayData.map(row => row.join(separator)).join("\n");
}

/**
 * Download csv file from csv formatted data
 * @param csvData
 * @param startFilename
 * @returns {Promise<void>}
 */
export const downloadCsvData = (csvData, startFilename) => {
  try {
    // Create file name with current date and organization
    const separator = '_';
    const date = getCustomFormattedDateBeginningByYear(getCurrentTimestamp(), separator);
    const fileName = [startFilename, date].join(separator);

    // Download data
    const encodedUri = encodeURI(csvData);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // Remove download link
    document.body.removeChild(link);

    return Promise.resolve();
  } catch {
    return Promise.reject('error while creating csv');
  }
}

export const downloadVideoFromUrl = async (videoUrl, filename) => {
  // Fetch the video as a blob
  const response = await fetch(videoUrl);
  const blob = await response.blob();

  // Create a temporary object URL
  const url = URL.createObjectURL(blob);

  // Create a temporary link element
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};